<template>
  <v-data-table
    :headers="headers"
    :items="detalles"
    hide-default-footer
    disable-pagination
    dense
    class="custom-clean-table"
    item-key="id"
  >
    <!-- WRAPPER DE FILA PARA RESALTADO -->
    <template v-slot:item="{ item, index }">
      <tr
        :class="['custom-row', { 'row-active': index === selectedIndex }]"
        @click="$emit('row-click', index)"
      >
        <td v-for="header in headers" :key="header.value">
          
          <!-- DESCRIPCIÓN -->
          <template v-if="header.value === 'descripcion_concepto'">
            <slot name="descripcion_concepto" :item="item" />
          </template>

          <!-- CANTIDAD -->
          <template v-else-if="header.value === 'cantidad'">
            <slot name="cantidad" :item="item" />
          </template>

          <!-- PRECIO -->
          <template v-else-if="header.value === 'precioUnitario'">
            <slot name="precioUnitario" :item="item">
              {{ item.precioUnitario }}
            </slot>
          </template>

          <!-- IVA -->
          <template v-else-if="header.value === 'vat_type'">
            <slot name="vat_type" :item="item" />
          </template>

          <!-- SUBTOTAL -->
          <template v-else-if="header.value === 'subTotal'">
            <slot name="subTotal" :item="item" />
          </template>

          <!-- ACCIONES -->
          <template v-else-if="header.value === 'actions'">
            <slot name="actions" :item="item" />
          </template>

        </td>
      </tr>
    </template>

    <!-- EMPTY STATE -->
    <template v-slot:no-data>
      <div class="empty-state">
        <v-icon large color="grey lighten-2">
          mdi-cart-outline
        </v-icon>
        <p>Tu lista está vacía</p>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "DetalleComprobanteTable",

  props: {
    detalles: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
   selectedIndex: {
  type: Number,
  default: -1
}
  },
};
</script>

<style scoped>
.custom-clean-table {
  background: transparent !important;
}

.custom-row {
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.row-active {
  background-color: rgba(25, 118, 210, 0.08);
  border-left: 4px solid #1976d2;
}

.empty-state {
  padding: 40px;
  color: #b2bec3;
  text-align: center;
}
</style>